import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-fahrzeugtyp-list-view',
  imports: [],
  templateUrl: './fahrzeugtyp.list-view.html',
  styleUrls: ['./fahrzeugtyp.list-view.css'],
})
export class FahrzeugtypListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
